import { motion } from "framer-motion";
import bannerImage from "../assets/banner.png";
import clinicImage from "../assets/clinic.jpg";
import logoImage from "../assets/logo.png";
import "../styles.css";
import Navbar from "./Navbar";

export default function Banner() {
  return (
    <header className="banner">
        <Navbar />
        <div className="bannerContent">
            
            <motion.h1 initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }}>
            Transforme sua vida <br />em um sorriso perfeito
            
            </motion.h1>
            
        </div>
        <input 
          type="button"   
          onClick={(e) => {
            e.preventDefault();
            window.open("https://wa.me/5511930693338?text=Oi!%20Gostaria%20de%20receber%20atendimento.", "_blank");
            // Rastreamento de conversão do Google Ads
            if (window.gtag) {
              window.gtag('event', 'conversion', {
                'send_to': 'AW-16944490858/aL4_CM-jl7MaEOrS4Y8_',
                'value': 1
              });
            }
          }} 
          className="cta-button" 
          value="Agende sua consulta" 
        />
    </header>
  );
}